<template>
    <div>
        <my-form v-model="form" readonly table>
            <my-form-item-group title="中标/招标结果通知书详情">
                <el-form-item label="选择标段" prop="bdname">
                    {{form.bdname||'-'}}
                </el-form-item>
                <el-form-item label="通知书编号" prop="tzscode">
                    {{form.tzscode||'-'}}
                </el-form-item>
                <el-form-item label="通知书类型" prop="typename">
                    {{form.typename||'-'}}
                </el-form-item>
                <el-form-item label="中标人/未中标人" prop="zbdwname">
                    {{form.zbdwname||'-'}}
                </el-form-item>
                <el-form-item label="报价类型">
                    <span v-if="form.bjlx==='2'">费率/比率/优惠率/合格率等</span>
                    <span v-if="form.bjlx==='3'">单价</span>
                    <span v-if="form.bjlx==='4'">其他形式</span>
                    <span v-if="form.bjlx==='1'">金额</span>
                    <span v-if="form.bjlx===''">金额</span>
                    <span v-else>-</span>
                </el-form-item>
                <el-form-item label="中标/投标价格">
                    <span v-if="form.bjlx==='1'">{{form.zbjg||'-'}}{{form.jgdwname}}  {{form.bzname}}</span>
                    <span v-if="form.bjlx!=='1'">{{form.zbbj||'-'}}</span>
                </el-form-item>
                <el-form-item label="通知书文本" class="table-full-row">
                    <div v-html="form.tzscontent"></div>
                </el-form-item>
                <el-form-item label="附件" class="table-full-row">
                    <my-upload readonly  :file-guid="form.fileguid">
                        
                    </my-upload>
                </el-form-item>
            </my-form-item-group>
        </my-form>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            fileguid:'',
            form:{}
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {


    },
    created() {
        
    },
    mounted() {
        var that=this;
        if(this.$route.query.id!=undefined){
            that.$get(`${this.getGetters('mngUrl')}/manage/business/audittzs/detail.json`,{id:this.$route.query.id}, (res,data) => {
                that.form=data.t.zbjgtzsinfo
            });
        }
    }
}
</script>

<style scoped lang="scss">

</style>
